export const Routes = {
  // public
  login: "/login",
  signUp: "/sign-up",
  signUpVerification: "/sign-up-verification",
  resetPassword: "/reset-password",
  expiredDirectLink: "/expired_direct_link",
  accountSignUp: "/account-sign-up",

  // protected
  notFound: "/404",
  expired: "/invitation_expired",
  fallback: "/error",
  dashboard: "/main/dashboard",
  newsFeed: "/main/news-feed",
  main: "/main",
  freemium: "/main/freemium",
  freemiumTools: "/main/freemium/tools",
  freemiumCommunity: "/main/freemium/community",
  myDeals: "/main/my-deals",
  mySecurities: "/main/my-securities",
  profile: "/main/profile",
  deal: "/main/deal/:deal_id",
  changePassword: "/main/change_password",
  taskManagement: "/main/task_management",
  tagger: "/main/tagger",
  benchmark: "/main/benchmark",
  benchmarkPerformance: "/main/benchmark/performance",
  benchmarkLiquidity: "/main/benchmark/liquidity",
  // Sidebar Routes
  // Investors Routes
  adminTools: "/main/admin_tools",
  investorsList: "/main/admin_tools/investors_list",
  measures: "/main/admin_tools/measures",
  characteristics: "/main/admin_tools/characteristics",
  assets: "/main/admin_tools/assets",
  assetClasses: "/main/admin_tools/assets/asset_classes",
  indexes: "/main/admin_tools/assets/indexes",
  objectiveDefaults: "/main/admin_tools/objective-defaults",
  accountSettings: "/main/account-settings",
  // Report Routes
  reports: "/main/reports",
  timeline: "/main/reports/timeline",
  snapshot: "/main/reports/snapshot",
  classic: "/main/reports/classic",
  cashflow: "/main/reports/cashflow",
  comparison: "/main/reports/comparison",
  externalReport: "/main/reports/external_report",
  reportGenerator: "/main/report_generator",
  monitoring: "/main/reports/monitoring",
  monitoringData: "/main/reports/monitoring/data",
  monitoringDataWide: "/main/reports/monitoring/data/wide",
  monitoringDrafts: "/main/reports/monitoring/drafts",
  fileRepository: "/main/reports/monitoring/file-repository",
  aiData: "/main/reports/monitoring/ai-data",
  consolidation: "/main/reports/monitoring/consolidation",
  consolidationSecurities: "/main/reports/monitoring/consolidation/securities",
  consolidationMeasures: "/main/reports/monitoring/consolidation/measures",
  consolidationAssetClasses: "/main/reports/monitoring/consolidation/asset-classes",
  debtPayments: "/main/reports/monitoring/debt",
  expectedPayments: "/main/reports/monitoring/debt/expected-payments",
  debtAmortizationTable: "/main/reports/monitoring/debt/amortization-table",
  // Deal Workspace Routes
  dealWorkspace: "/main/deal/:deal_id/workspace",
  dealWorkspaceAllFiles: "/main/deal/:deal_id/workspace/all-files",
  dealWorkspaceRecentlyAdded: "/main/deal/:deal_id/workspace/recently-added",
  dealForm: "/main/deal/:deal_id/workspace/form/:form_id",
  dealFile: "/main/deal/:deal_id/workspace/file/:file_id",
  dealEmail: "/main/deal/:deal_id/workspace/email/:email_id",
  dealFolder: "/main/deal/:deal_id/workspace/folder/:folder_id",
  dealEmails: "/main/deal/:deal_id/workspace/emails/:folder_id",
  dealNews: "/main/deal/:deal_id/workspace/news/:folder_id",
  dealMeetings: "/main/deal/:deal_id/workspace/meetings/:folder_id",
  // dealDataRooms: "/main/deal/:deal_id/workspace/data_rooms/:data_room_id",
  dealDataRoom: "/main/deal/:deal_id/workspace/data_room/:folder_id",
  dealDocument: "/main/deal/:deal_id/workspace/documents/:document_id",
  // Rest Deal Routes
  dealFormBlank: "/main/deal/:deal_id/form-not-exist",
  dealTemplate: "/main/deal/:deal_id/template",
  dealNotes: "/main/deal/:deal_id/notes",
  dealNote: "/main/deal/:deal_id/workspace/note/:note_id",
  dealNoteInfo: "/main/deal/:deal_id/workspace/note_info/:note_id",
  dealTaskManage: "/main/deal/:deal_id/task_manage",
  dealMonitoring: "/main/deal/:deal_id/monitoring",
  dealMonitoringData: "/main/deal/:deal_id/monitoring/data",
  dealMonitoringDrafts: "/main/deal/:deal_id/monitoring/drafts",
  dealMonitoringFees: "/main/deal/:deal_id/monitoring/fees",
  dealMonitoringSecurities: "/main/deal/:deal_id/monitoring/securities",
  dealMonitoringWide: "/main/deal/:deal_id/monitoring/wide",
  dealDashboard: "/main/deal/:deal_id/dashboard",
  dealLookThrough: "/main/deal/:deal_id/look_through",
  dealAmortization: "/main/deal/:deal_id/amortization",
  // data rooms
  dataRooms: "/main/data_rooms",
  dataRoomsFile: "/main/data_rooms/files/:uuid_request/:op",
  dataRoomsAllFiles: "/main/data_rooms/all_files",
  dataRoom: "/main/data_rooms/:room_id",
  dataRoomConnections: "/main/data_rooms/:room_id/connections",
  dataRoomFiles: "/main/data_rooms/:room_id/files",

  dealReport: "/main/deal/:deal_id/report",
  dealDebtReport: "/main/deal/:deal_id/report/debt",
  // dealTagger: "/main/tagger/:deal_id",
  //quick view
  quickView: "/main/quick_view",
  //Social
  socialProfile: "/main/social_profile",
  social: "/main/social",
  // Opportunities Routes
  opportunities: "/main/opportunities",
  // Plaid routs
  plaid: "/main/plaid",
  plaidConnection: "/main/plaid/:connection",
  // Users management
  usersManagement: "/main/users-management",
  users: "/main/users-management/users",
  teams: "/main/users-management/teams",
  investmentEntities: "/main/users-management/investment_entities",
  // investmentEntities: "/main/investment-entities"
  // Other tools
  gptPrompt: "/main/gpt-prompt",
  //Global document
  documents: "/main/documents",
  documentsGeneral: "/main/documents/general",
  documentsAllDocuments: "/main/documents/all_documents",
  documentsDeals: "/main/documents/deals",
  documentId: "/main/documents/:tab/:document_id",
  // Global workspace
  workspace: "/main/workspace",
  workspaceAllFiles: "/main/workspace/all-files",
  workspaceRecentlyAdded: "/main/workspace/recently-added",
  // Global workspace deal routes
  workspaceDeals: "/main/workspace/deals",
  workspaceDeal: "/main/workspace/deal/:deal_id",
  workspaceDealFolder: "/main/workspace/deal/:deal_id/folder/:folder_id",
  workspaceDealFolderDocument: "/main/workspace/deal/:deal_id/folder/:folder_id/document/:document_id",
  workspaceDealFolderForm: "/main/workspace/deal/:deal_id/folder/:folder_id/form/:form_id",
  // Global workspace no deals routes
  workspaceFolders: "/main/workspace/folders",
  workspaceFolder: "/main/workspace/folder/:folder_id",
  workspaceFolderDocument: "/main/workspace/folder/:folder_id/document/:document_id",
  workspaceFolderForm: "/main/workspace/folder/:folder_id/form/:form_id",
  //Portfolio construction
  portfolioConstruction: "/main/portfolio-construction",
  portfolioConstructionInvestor: "/main/portfolio-construction/investor/:investor_id",
  portfolioConstructionSlice: "/main/portfolio-construction/slice/:slice_id",
  portfolioConstructionInvestorAllocation: "/main/portfolio-construction/investor/:investor_id/allocation",
  portfolioConstructionInvestorCorrelation: "/main/portfolio-construction/investor/:investor_id/correlation"
} as const;
